module.exports = __webpack_public_path__ + "img/New Year.2febee5f.jpeg";